// src/components/ui/exclusao/ConfirmDialog.jsx
import { motion, AnimatePresence } from "framer-motion";
import { FaQuestionCircle, FaCheck, FaTimes } from "react-icons/fa";

export default function ConfirmDialog({ open, message, onConfirm, onCancel }) {
  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Fundo escuro */}
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-70 z-[1000]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Caixa do modal */}
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-[1001]"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <div
              className="shadow-lg border"
              style={{
                width: "350px",
                backgroundColor: "#E8E8E8",
                border: "1px solid #606060",
                borderRadius: "6px",
                fontFamily: "Source Sans Pro, sans-serif",
              }}
            >
              {/* Cabeçalho */}
              <div
                className="px-3 py-2 flex justify-between items-center"
                style={{ backgroundColor: "#303030", color: "white" }}
              >
                <h2 className="text-sm font-semibold">Exclusão de Registro</h2>

                {/* Botão de fechar */}
                <button
                  onClick={onCancel}
                  className="p-1 hover:bg-gray-600 rounded"
                >
                  <FaTimes className="text-white text-sm opacity-80" />
                </button>
              </div>

              {/* Mensagem */}
              <div
                className="px-4 py-3 flex items-center gap-2 text-sm"
                style={{ backgroundColor: "#dfdfdf" }}
              >
                <FaQuestionCircle className="text-gray-700 text-lg" />
                <p className="text-gray-800">{message}</p>
              </div>

              <hr className="border-t border-[#606060]" />

              {/* Botões */}
              <div className="flex justify-end gap-3 px-4 py-2">
                <button
                  onClick={onCancel}
                  className="flex items-center gap-2 px-5 py-1 text-white text-sm transition hover:opacity-90"
                  style={{
                    backgroundColor: "#bc3823",
                    borderRadius: "4px",
                    border: "1px solid #c0c0c0",
                  }}
                >
                  <FaTimes className="text-white text-xs" />
                  Não
                </button>
                <button
                  onClick={onConfirm}
                  className="flex items-center gap-2 px-5 py-1 text-white text-sm transition hover:opacity-90"
                  style={{
                    backgroundColor: "#1d7f14",
                    borderRadius: "4px",
                    border: "1px solid #c0c0c0",
                  }}
                >
                  <FaCheck className="text-white text-xs" />
                  Sim
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
